export default __webpack_public_path__ + "static/media/cards_es.d6a24d5b.png";